module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('h1', {
    staticClass: "block_1",
    attrs: {
      "id": "toc_id_1"
    }
  }, [_vm._v("About the Author")]), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("To the reader:")]), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_3"
  }, [_vm._v("Since before I could remember, the imagined shaped every aspect of my life. From the toys that came alive when given a name and a voice, to the world around me that melted into something more than initially met the eye. Although not all living creatures could tell their stories, I found solace and deeper understanding when I witnessed their context and gave them a voice. ")]), _vm._v(" "), _c('p', {
    staticClass: "block_3"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_3"
  }, [_vm._v("This was not only where I had the best times, but the place that I have fought desperately to remain in throughout my life. ")]), _vm._v(" "), _c('p', {
    staticClass: "block_3"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_3"
  }, [_vm._v("In short, I have always feared the day when enchantment, wonder and mystery would suffer genocide. Only to be revisited by the occasional, short-lived nostalgic moment. ")]), _vm._v(" "), _c('p', {
    staticClass: "block_3"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_3"
  }, [_vm._v("Although flying dragons, monsters and other mythical beasts may forever exist in fantasy, let us do our very best in creating a compassionate, loving, and peaceful world. ")]), _vm._v(" "), _c('p', {
    staticClass: "block_3"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_3"
  }, [_vm._v("One that won’t merely be found in the fiction section of our local bookstores but littered between the pages of our lives.")]), _vm._v(" "), _c('p', {
    staticClass: "block_4",
    attrs: {
      "id": "calibre_pb_0"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75c112f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_000.vue
// module id = 63
// module chunks = 0